<div class="content-grid-installation">
  <!-- ===== LEFT: État ===== -->
  <app-installation-etat-panel
    [chargement]="chargement"
    [erreurChargement]="erreurChargement"
    [installation]="installation"
    [defautsPrecharges]="defautsPrecharges"
    [chiffresUtiles]="chiffresUtiles"
  />

  <!-- ===== CENTER: Graphiques & métriques ===== -->
  <div class="main-column">
    <section class="hero-row">
      <article class="weather-card">
        <div class="weather-art" aria-hidden="true">
          @if (meteo) {
            <span
              class="material-symbols-outlined weather-art-icon"
              [style.color]="meteo.couleur"
              >{{ meteo.icone }}</span
            >
          } @else {
            <span class="sun-art"></span>
          }
        </div>
        <div class="weather-copy">
          <span class="date-label">{{ dateLabel }}</span>
          <p>{{ installation?.nom }}</p>
          @if (meteo) {
            <strong>{{ meteo.temperature }}&deg;C</strong>
          } @else {
            <strong>—</strong>
          }
        </div>
      </article>

      <div class="metric-grid">
        <article class="metric-card">
          <span class="metric-title">Puissance moy.</span>
          <strong
            >{{
              $safeNavigationMigration(chiffresUtiles?.puissance) | puissanceUnite
            }}</strong
          >
        </article>
        <article class="metric-card">
          <span class="metric-title">Énergie cumulée</span>
          <strong
            >{{
              $safeNavigationMigration(chiffresUtiles?.energie_cumulee) | energieUnite
            }}</strong
          >
        </article>
        <article class="metric-card">
          <span class="metric-title">CO₂ évité</span>
          <strong
            >{{
              $safeNavigationMigration(chiffresUtiles?.co2_evite) | co2Unite
            }}</strong
          >
        </article>
        <article class="metric-card">
          <span class="metric-title">Gains cumulés</span>
          <strong
            >{{
              $safeNavigationMigration(chiffresUtiles?.revenus_cumules) | deviseUnite
            }}</strong
          >
        </article>
      </div>
    </section>

    <section class="chart-card line-chart">
      <div class="chart-header">
        <h2>Production de l'installation</h2>
        <div class="chart-header-actions">
          <app-chart-period-selector
            [mode]="modeAffichage"
            [dateFin]="dateFin"
            (periodeChange)="onPeriodeChange($event)"
          />
          <div class="chart-menu-wrapper">
            <button
              class="menu-dots"
              aria-label="Options du graphique"
              (click)="toggleMenuPuissance($event)"
            >
              <span></span>
            </button>
            @if (menuPuissanceOuvert) {
              <div class="chart-dropdown" role="menu">
                <button
                  class="chart-dropdown-item"
                  role="menuitem"
                  (click)="ouvrirModalPuissance()"
                >
                  <span class="material-symbols-outlined">fullscreen</span>
                  Afficher en grand
                </button>
              </div>
            }
          </div>
        </div>
      </div>

      <!-- Graphique amCharts5 généré dans installation-chart-puissance.ts -->
      <app-chart-host-overlay
        class="chart-area chart-area-line"
        [loading]="chargementGraphique"
        loadingLabel="Chargement du graphique..."
        ariaLabel="Graphique de production"
        (hostReady)="onProductionChartReady($event)"
      />
    </section>

    <app-chart-fullscreen-modal
      title="Production de l'installation"
      [chartRenderer]="productionChartRenderer"
      [(visible)]="modalPuissanceVisible"
      [refreshToken]="modalRefreshToken"
      [loading]="chargementGraphique"
    >
      <div chart-controls class="chart-header-actions">
        <app-chart-period-selector
          [mode]="modeAffichage"
          [dateFin]="dateFin"
          (periodeChange)="onPeriodeChange($event)"
        />
      </div>
    </app-chart-fullscreen-modal>

    <app-installation-production-cumulee-panel
      [installationId]="installation?.id ?? null"
      [autoconso]="estAutoconso"
    />
  </div>

  <!-- ===== RIGHT: Caractéristiques ===== -->
  <div class="panel carac-panel">
    <section class="summary-card">
      <h2>Caractéristiques</h2>
      <div class="map-card" style="margin-top: 12px">
        <app-carte-installations [installations]="installation ? [installation] : []" />
      </div>

      @if (installation) {
        <ul class="feature-list-install">
          <li>
            <span class="material-symbols-outlined fi-icon">location_on</span>
            <div class="fi-content">
              <span class="fi-label">Adresse de la centrale</span>
              <span class="fi-value">{{ adresse }}</span>
            </div>
          </li>
          <li>
            <span class="material-symbols-outlined fi-icon">calendar_month</span>
            <div class="fi-content">
              <span class="fi-label">Date de mise en service</span>
              <span class="fi-value">{{ miseEnService }}</span>
            </div>
          </li>
          <li>
            <span class="material-symbols-outlined fi-icon">euro</span>
            <div class="fi-content">
              <span class="fi-label">Vente totale</span>
              <span class="fi-value">{{ tarifFormate }} c€/kWh</span>
            </div>
          </li>
          <li>
            <span class="material-symbols-outlined fi-icon">bolt</span>
            <div class="fi-content">
              <span class="fi-label">Cardi</span>
              <span class="fi-value maquette-statique">Puissance raccordement : 310 kW</span>
            </div>
          </li>
          <li>
            <span class="material-symbols-outlined fi-icon">settings_input_component</span>
            <div class="fi-content">
              <span class="fi-label">Consigne soutirage</span>
              <span class="fi-value maquette-statique">Coef. faible prod. : 20%</span>
              <span class="fi-value maquette-statique">Tangphi : 0</span>
              <span class="fi-value maquette-statique">Plage forte prod. : -0,1</span>
              <span class="fi-value maquette-statique">Plage faible prod. : 394 kVAr</span>
            </div>
          </li>
        </ul>
      }
    </section>

    <section class="accordion-block">
      <a href="#" class="accordion-item maquette-statique">Matériel</a>
      <a href="#" class="accordion-item maquette-statique">Acquisition</a>
      <a href="#" class="accordion-item maquette-statique">Contrats</a>
      <app-installation-contacts-panel [installation]="installation" />
    </section>
  </div>
</div>
